import Address from "./vehicle/address";
import Engine from "./vehicle/engine";
import Mpg from "./vehicle/mpg";
import Transmission from "./vehicle/transmission";
import VehicleJson from "./vehicleJson";

export default class Vehicle {
  createdAt: string | null;
  currentAddress: Address;
  engine: Engine;
  id: string | null;
  imageUrl: string | null;
  lastSalePrice: number | null;
  make: string | null;
  model: string | null;
  mpg: Mpg;
  msrp: number | null;
  purchasedAt: string | null;
  saleClass: string | null;
  transmission: Transmission;
  updatedAt: string | null;
  vin: string | null;
  year: number | null;

  constructor() {
    this.createdAt = null;
    this.currentAddress = new Address();
    this.engine = new Engine();
    this.id = null;
    this.imageUrl = null;
    this.lastSalePrice = null;
    this.make = null;
    this.model = null;
    this.mpg = new Mpg();
    this.msrp = null;
    this.purchasedAt = null;
    this.saleClass = null;
    this.transmission = new Transmission();
    this.updatedAt = null;
    this.vin = null;
    this.year = null;
  }

  static fromJSON(json: VehicleJson): Vehicle {
    const vehicle = new Vehicle();

    vehicle.createdAt = json.createdAt;
    vehicle.currentAddress = Address.fromJSON(json.currentAddress);
    vehicle.engine = Engine.fromJSON(json.engine);
    vehicle.id = json.id;
    vehicle.imageUrl = json.imageUrl;
    vehicle.lastSalePrice = json.lastSalePrice;
    vehicle.make = json.make;
    vehicle.model = json.model;
    vehicle.mpg = Mpg.fromJSON(json.mpg);
    vehicle.msrp = json.msrp;
    vehicle.purchasedAt = json.purchasedAt;
    vehicle.saleClass = json.saleClass;
    vehicle.transmission = Transmission.fromJSON(json.transmission);
    vehicle.updatedAt = json.updatedAt;
    vehicle.vin = json.vin;
    vehicle.year = json.year;

    return vehicle;
  }

  toJSON(): any {
    return {
      make: this.make,
      model: this.model,
      vin: this.vin,
      year: this.year,
    };
  }

  displayName(): string {
    return [this.year, this.make, this.model]
      .filter((x) => x != null)
      .join(" ");
  }

  horsepower(): string | null {
    if (this.engine.horsepower === null) {
      return null;
    }

    return `${this.engine.horsepower}hp`;
  }

  cityStateZipCode(): string | null {
    if (this.currentAddress == null) {
      return null;
    }

    const items = [
      this.currentAddress.city,
      this.currentAddress.state,
      this.currentAddress.zipCode,
    ];

    if (items.length == 0) {
      return null;
    } else {
      return items.filter((x) => x != null).join(" ");
    }
  }
}
